// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_dg-2";
export var aiChatCartContainerExit = "_dg-4";
export var aiChatContainerLarge = "_dg-0";
export var aiChatContainerSmall = "_dg-1";
export var aiChatIcon = "_dg-6";
export var slideInFromRight = "_dg-3";
export var slideOutToRight = "_dg-5";